/** Display URL for the first project image (YouTube/Vimeo links and uploaded videos with thumbnails). */
export const getProjectThumbnailUrl = (project) => {
  if (!project) return null;

  const firstImage = project.images?.[0];
  const firstProcessedImage = project.processedImages?.[0];

  if (firstImage && typeof firstImage === "object") {
    const urlToCheck = firstImage.url || "";
    const isLink =
      firstImage.type === "link" ||
      (urlToCheck &&
        typeof urlToCheck === "string" &&
        (urlToCheck.includes("youtube.com") ||
          urlToCheck.includes("youtu.be") ||
          urlToCheck.includes("vimeo.com")));

    const isVideoFile =
      urlToCheck &&
      typeof urlToCheck === "string" &&
      /\.(mp4|mov|avi|wmv|flv|webm|mkv|m4v)$/i.test(urlToCheck);

    if (isLink && firstImage.thumbnailUrl) {
      return firstImage.thumbnailUrl;
    }

    if (isVideoFile) {
      if (
        firstProcessedImage &&
        typeof firstProcessedImage === "object" &&
        firstProcessedImage.processedThumbnailUrl
      ) {
        return firstProcessedImage.processedThumbnailUrl;
      }
      if (firstImage.thumbnailUrl) {
        return firstImage.thumbnailUrl;
      }
    }
  }

  if (typeof firstProcessedImage === "string") {
    return firstProcessedImage;
  }

  return (
    firstProcessedImage?.processedUrl ||
    firstProcessedImage?.url ||
    firstImage?.url ||
    null
  );
};

/** Cover image for project lists/modals: audio cover first, then visual thumbnail logic. */
export const getProjectCoverImage = (project) => {
  const audioData = project?.audios?.[0];
  const fromAudio =
    audioData?.processedCoverImage || audioData?.coverImage || null;

  if (fromAudio) return fromAudio;

  return getProjectThumbnailUrl(project) || "";
};
